var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMajorAlertTimelineWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4834_61469)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E0E2E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 10.8V9.66667L12.0013 6L17.3346 9.66667V10.8L12.0013 7.33333L6.66797 10.8Z",
    fill: "#EEC100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 14.1333V13L12.0013 9.33333L17.3346 13V14.1333L12.0013 10.6667L6.66797 14.1333Z",
    fill: "#EEC100"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.66797 17.466V16.3327L12.0013 12.666L17.3346 16.3327V17.466L12.0013 13.9993L6.66797 17.466Z",
    fill: "#EEC100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4834_61469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMajorAlertTimelineWhite);
export default __webpack_public_path__ + "static/media/major-alert-timeline-white.720040e6dd6452d6fb5e96b5ffb87c0c.svg";
export { ForwardRef as ReactComponent };